        class ApiError extends Error {
            constructor(message, { status = 0, code = '', details = null } = {}) {
                super(message);
                this.name = 'ApiError';
                this.status = status;
                this.code = code;
                this.details = details;
            }
        }

        // Helper function to make API calls with fetch
        async function makeApiCall(endpoint, method = 'GET', data = null, headers = {}) {
            const baseURL = 'https://server-2e6235pjbq-uc.a.run.app';
            const url = `${baseURL}${endpoint}`;
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 15000);
            
            const options = {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    ...headers
                },
                signal: controller.signal
            };
            
            if (data) {
                options.body = JSON.stringify(data);
            }
            
            try {
                const response = await fetch(url, options);
                const contentType = response.headers.get('content-type') || '';
                let responseData = null;

                if (contentType.includes('application/json')) {
                    responseData = await response.json();
                } else {
                    const text = await response.text();
                    responseData = text ? { descripcion: text } : null;
                }

                if (!response.ok) {
                    throw new ApiError(
                        responseData?.descripcion || responseData?.message || 'La solicitud no pudo completarse',
                        {
                            status: response.status,
                            code: responseData?.code || '',
                            details: responseData?.errors || null
                        }
                    );
                }

                if (responseData?.status === false) {
                    throw new ApiError(
                        responseData.descripcion || 'La solicitud no pudo completarse',
                        {
                            status: response.status,
                            code: responseData.code || '',
                            details: responseData.errors || null
                        }
                    );
                }

                return responseData;
            } catch (error) {
                if (error.name === 'AbortError') {
                    throw new ApiError('La solicitud tardó demasiado', {
                        status: 408,
                        code: 'REQUEST_TIMEOUT'
                    });
                }
                if (error instanceof ApiError) throw error;
                throw new ApiError('No fue posible conectar con el servicio', {
                    status: 0,
                    code: 'NETWORK_ERROR'
                });
            } finally {
                clearTimeout(timeoutId);
            }
        }

        // Customer service functions
        const customerService = {

        // Get all customers
        getCustomers: async (params = {}) => {
            try {
            // const token = await customerService.login();
            // if (!token) throw new Error('No token available');
            
            const queryParams = new URLSearchParams();
            if (params.page) queryParams.append('page', params.page.toString());
            if (params.limit) queryParams.append('limit', params.limit.toString());
            if (params.search) queryParams.append('search', params.search);
            if (params.cursor) queryParams.append('cursor', params.cursor);
            if (params.query) queryParams.append('query', params.query);
            
            const response = await makeApiCall(`/api/get-customers-repo?${queryParams}`, 'GET', null
               //, {
                // 'Token': token
                // }
            );
            
            return response;
            } catch (error) {
            throw error;
            }
        },

        // Get customer by ID
        getCustomer: async (id) => {
            try {
            const response = await makeApiCall(`/customers/${id}`, 'GET');
            // console.log('Customer data:', response);
            return response.customer;
            } catch (error) {
            throw error;
            }
        },

        // Create customer
        createCustomer: async (customerData) => {
            try {
            const response = await makeApiCall('/api/customers', 'POST', customerData);
            // console.log('Created customer:', response);
            return response;
            } catch (error) {
            throw error;
            }
        },

        // Update customer
        updateCustomer: async (id, customerData) => {
            try {
                // console.log("DATOS ENVIADOS A UPDATE CUSTOMER", id, customerData);
            const response = await makeApiCall('/api/customers', 'PUT', {
                id,
                ...customerData
            });
            // console.log('Updated customer:', response);
            return response;
            } catch (error) {
            throw error;
            }
        },

        // Get customer metafields
        getCustomerMetafields: async (customerId) => {
            try {
            const response = await makeApiCall(`/api/metafields/${customerId}`, 'GET');
            // console.log('Metafields:', response);
            return response.metafields;
            } catch (error) {
            throw error;
            }
        },

        // Create/update metafield
        setMetafield: async (customerId, metafield) => {
            try {
            const response = await makeApiCall('/api/metafields', 'POST', {
                customerId,
                metafield
            });
            return response.metafield;
            } catch (error) {
            throw error;
            }
        },

        // Delete metafield
        deleteMetafield: async (customerId, metafieldId) => {
            try {
            await makeApiCall('/api/metafields', 'DELETE', {
                customerId,
                metafieldId
            });
            } catch (error) {
            throw error;
            }
        }
        };

        // Configuration
        const CONFIG = {
            REQUIRED_METAFIELDS: [
                //{ key: 'cumplea_os', namespace: 'customer_hub', type: 'date', columnName:'Cumpleaños' },
                //{ key: 'genero', namespace: 'customer_hub', type: 'list.single_line_text_field', columnName:'Género' },
                //{ key: 'nmero_y_calle', namespace: 'custom', type: 'single_line_text_field', columnName:'Calle y Número' },
                //{ key: 'cdigo_postal', namespace: 'custom', type: 'single_line_text_field', columnName:'Código Postal' },
                { key: 'cmo_te_identificas', namespace: 'custom', type: 'single_line_text_field', columnName:'Cómo te Identificas' },
                { key: 'protena_de_preferencia', namespace: 'custom', type: 'single_line_text_field', columnName:'Proteina de Preferencia' },
                { key: 'tus_compras_son_para', namespace: 'custom', type: 'single_line_text_field', columnName:'Tus Compras son para' },
                //{ key: 'mtodo_de_pago_de_preferencia', namespace: 'custom', type: 'list.single_line_text_field', columnName:'Método de Pago de preferencia' },
                //{ key: 'recurrencia_de_compra', namespace: 'custom', type: 'list.single_line_text_field', columnName:'Recurrencia de compra' },
                //{ key: 'ife', namespace: 'custom', type: 'single_line_text_field', columnName:'IFE' },
                //{ key: 'numero_sukarne', namespace: 'custom', type: 'single_line_text_field', columnName:'Número SK' }
            ],
            LIST_OPTIONS: {
                genero: ['Masculino', 'Femenino', 'Prefiero no mencionarlo'],
                cmo_te_identificas: ['Negocio', 'Emprendedor', 'Ama de casa', 'Consumidor Ocasional', 'Otro'],
                protena_de_preferencia: ['Res', 'Pollo', 'Cerdo', 'Pescado'],
                tus_compras_son_para: ['Mi negocio', 'Consumo personal'],
                mtodo_de_pago_de_preferencia: ['Pago en línea', 'Transferencia bancaria', 'Efectivo', 'Tarjeta'],
                recurrencia_de_compra: ['Semanal', 'Quincenal', 'Mensual', 'Otro']
            },
            METAFIELD_TYPES: ['string', 'integer', 'boolean', 'json', 'date', 'single_line_text_field', 'list.single_line_text_field']
        };

        // State
        let currentCustomer = null;
        let tags = [];
        let additionalMetafields = [];
        let isLoading = false;

        // DOM Elements
        const modal = document.getElementById('customerModal');
        const modalTitle = document.getElementById('modalTitle');
        const formCustomerRegistration = document.getElementById('customerForm');
        const closeButton = document.getElementById('closeButton');
        const cancelButton = document.getElementById('cancelButton');
        const submitButton = document.getElementById('submitButton');
        const addTagButton = document.getElementById('addTagButton');
        const newTagInput = document.getElementById('newTag');
        const tagsList = document.getElementById('tagsList');
        const addMetafieldButton = document.getElementById('addMetafieldButton');
        const metafieldsContainer = document.getElementById('metafieldsContainer');

        if(formCustomerRegistration){

            // Helper functions
            function showLoading() {
                isLoading = true;
                clearError();
                submitButton.disabled = true;
                submitButton.setAttribute('aria-busy', 'true');
                submitButton.innerHTML = '<span class="spinner"></span> Procesando...';
            }

            function hideLoading() {
                isLoading = false;
                submitButton.disabled = false;
                submitButton.removeAttribute('aria-busy');
                submitButton.textContent = currentCustomer ? 'Actualizar Cliente' : 'Registrarse';
            }

            function showError(message) {
                const errorContainer = document.getElementById('notification_errors');
                errorContainer.setAttribute('role', 'alert');
                errorContainer.setAttribute('aria-live', 'assertive');
                errorContainer.classList.remove('hidden');
                errorContainer.textContent = message;
                errorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            function clearError() {
                const errorContainer = document.getElementById('notification_errors');
                if (!errorContainer) return;
                errorContainer.textContent = '';
                errorContainer.classList.add('hidden');
            }

            function getFriendlyErrorMessage(error) {
                const safeMessagesByCode = {
                    INVALID_EMAIL: 'Revisa el correo electrónico e intenta nuevamente.',
                    INVALID_EMAIL_DOMAIN: 'El dominio del correo electrónico no es válido o no puede recibir mensajes.',
                    EMAIL_DOMAIN_CHECK_UNAVAILABLE: 'No pudimos validar el correo en este momento. Intenta nuevamente en unos minutos.',
                    REQUEST_TIMEOUT: 'La solicitud tardó demasiado. Revisa tu conexión e intenta nuevamente.',
                    NETWORK_ERROR: 'No pudimos conectar con el servicio. Revisa tu conexión e intenta nuevamente.'
                };

                if (safeMessagesByCode[error?.code]) return safeMessagesByCode[error.code];

                if (Array.isArray(error?.details) && error.details.length > 0) {
                    const mappedMessages = mapShopifyUserErrorsToSpanish(error.details);
                    if (mappedMessages.length > 0) return mappedMessages.join(' ');
                }

                if (error?.status === 400 || error?.status === 422) {
                    return 'Revisa la información capturada e intenta nuevamente.';
                }
                if (error?.status === 409) {
                    return 'Ya existe un registro con estos datos. Verifica tu correo o teléfono.';
                }
                if (error?.status === 408) {
                    return 'La solicitud tardó demasiado. Intenta nuevamente.';
                }
                if (error?.status === 429) {
                    return 'Se realizaron demasiados intentos. Espera un momento antes de continuar.';
                }
                if (error?.status >= 500) {
                    return 'El servicio no está disponible por el momento. Intenta nuevamente más tarde.';
                }
                return 'No pudimos guardar tus datos. Intenta nuevamente.';
            }

            // API Service
            const api = customerService;

            // Tag management
            function addTag(tag) {
                const trimmedTag = tag.trim();
                if (trimmedTag && !tags.includes(trimmedTag)) {
                    tags.push(trimmedTag);
                    renderTags();
                    newTagInput.value = '';
                }
            }

            function removeTag(tagToRemove) {
                tags = tags.filter(tag => tag !== tagToRemove);
                renderTags();
            }

            function renderTags() {
                tagsList.innerHTML = '';
                tags.forEach(tag => {
                    const tagElement = document.createElement('span');
                    tagElement.className = 'tag';
                    tagElement.textContent = tag;

                    const removeButton = document.createElement('button');
                    removeButton.className = 'tag-remove';
                    removeButton.innerHTML = '×';
                    removeButton.onclick = () => removeTag(tag);

                    tagElement.appendChild(removeButton);
                    tagsList.appendChild(tagElement);
                });
            }

            // Metafield management
            function addMetafield() {
                additionalMetafields.push({
                    id: null,
                    namespace: 'custom',
                    key: '',
                    value: '',
                    type: 'string',
                    columnName: ''
                });
                renderMetafields();
            }

            function removeMetafield(index) {
                // Check if it's a required metafield
                const metafield = additionalMetafields[index];
                const isRequired = CONFIG.REQUIRED_METAFIELDS.some(field => field.key === metafield.key);
                
                if (isRequired) {
                    showCustomAlert("Este es un campo requerido y no puede ser eliminado.");
                    return;
                }

                additionalMetafields.splice(index, 1);
                renderMetafields();
            }

            function updateMetafield(index, field, value) {
                if (additionalMetafields[index]) {
                    additionalMetafields[index][field] = value;
                }
            }

            function renderMetafields() {
                metafieldsContainer.innerHTML = '';

                additionalMetafields.forEach((metafield, index) => {
                    const isRequired = CONFIG.REQUIRED_METAFIELDS.some(field => field.key === metafield.key);

                    const metafieldElement = document.createElement('div');
                    metafieldElement.className = 'metafield-item';
                    //For hidde metafields provisional
                    metafieldElement.className = 'hidden';

                    // Namespace
                    const namespaceCol = document.createElement('div');
                    namespaceCol.className = 'metafield-col col-3';
                    namespaceCol.innerHTML = `
                        <label class="form-label hidden">Namespace</label>
                        <input type="text" 
                            value="${metafield.namespace}" 
                            onchange="updateMetafield(${index}, 'namespace', this.value)"
                            class="form-input hidden"
                            ${isRequired ? 'readonly' : ''}>
                    `;

                    // Key
                    const keyCol = document.createElement('div');
                    keyCol.className = 'metafield-col col-3';
                    keyCol.innerHTML = `
                        <label class="form-label hidden">Key</label>
                        <input type="text" 
                            value="${metafield.key}" 
                            onchange="updateMetafield(${index}, 'key', this.value)"
                            class="form-input hidden"
                            ${isRequired ? 'readonly' : ''}>
                    `;

                    // Type
                    const typeCol = document.createElement('div');
                    typeCol.className = 'metafield-col col-2';
                    typeCol.innerHTML = `
                        <label class="form-label hidden">Tipo</label>
                        <select onchange="updateMetafield(${index}, 'type', this.value)" 
                                class="form-select hidden"
                                ${isRequired ? 'disabled' : ''}>
                            ${CONFIG.METAFIELD_TYPES.map(type => `
                                <option value="${type}" ${metafield.type === type ? 'selected' : ''}>${type}</option>
                            `).join('')}
                        </select>
                    `;

                    // Value
                    const valueCol = document.createElement('div');
                    valueCol.className = 'metafield-col col-3';
                    
                    let valueInput = '';
                    if (metafield.type === 'date') {
                        valueInput = `<input type="date" 
                                        value="${metafield.value}" 
                                        onchange="updateMetafield(${index}, 'value', this.value)"
                                        class="form-input">`;
                    } else if (metafield.type === 'list.single_line_text_field') {
                        const options = CONFIG.LIST_OPTIONS[metafield.key] || [];
                        valueInput = `
                            <select onchange="updateMetafield(${index}, 'value', JSON.stringify([this.value]))" 
                                    class="form-select">
                                <option value="">Seleccionar...</option>
                                ${options.map(option => `
                                    <option value="${option}" ${metafield.value === JSON.stringify([option]) ? 'selected' : ''}>
                                        ${option}
                                    </option>
                                `).join('')}
                            </select>
                        `;
                    } else {
                        valueInput = `<input type="text" 
                                        value="${metafield.value}" 
                                        onchange="updateMetafield(${index}, 'value', this.value)"
                                        class="form-input"
                                        placeholder="Valor">`;
                    }

                    valueCol.innerHTML = `
                        <label class="form-label">${metafield.columnName}</label>
                        ${valueInput}
                    `;

                    // Remove button
                    const removeCol = document.createElement('div');
                    removeCol.className = 'metafield-col col-1';
                    removeCol.innerHTML = `
                        <button type="button" 
                                onclick="removeMetafield(${index})" 
                                class="metafield-remove hidden"
                                ${isRequired ? 'disabled' : ''}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                            </svg>
                        </button>
                    `;

                    metafieldElement.appendChild(namespaceCol);
                    metafieldElement.appendChild(keyCol);
                    metafieldElement.appendChild(typeCol);
                    metafieldElement.appendChild(valueCol);
                    metafieldElement.appendChild(removeCol);

                    metafieldsContainer.appendChild(metafieldElement);
                });
            }

            // Form handling
            function loadCustomerData(customer) {
                currentCustomer = customer;
                
                // Basic fields
                const firstNameElement = document.getElementById('first_name');
                const lastNameElement = document.getElementById('last_name');
                const emailFormElement = document.getElementById('email');
                const phoneElement = document.getElementById('phone');
                const comoIdentificasElement = document.getElementById('cmo_te_identificas');
                const proteinaPreferenciaElement = document.getElementById('proteina_preferencia');
                const paraElement = document.getElementById('tus_compras_son_para');
                const firstNameLabelElement = document.getElementById('first_name_label');
                const lastNameLabelElement = document.getElementById('last_name_label');
                const emailFormLabelElement = document.getElementById('email_label');
                const phoneLabelElement = document.getElementById('phone_label');
                const comoIdentificasLabelElement = document.getElementById('cmo_te_identificas_label');
                const proteinaPreferenciaLabelElement = document.getElementById('proteina_preferencia_label');
                const paraLabelElement = document.getElementById('tus_compras_son_para_label');

                firstNameElement.value = customer.Nombre || '';
                lastNameElement.value = customer.Apellido || '';
                emailFormElement.value = customer.CorreoElectronico || '';
                phoneElement.value = customer.Telefono || '';

                //Set editable false email
                if (emailFormElement && emailFormElement.value !== "") {
                    emailFormElement.readOnly = true;
                    emailFormLabelElement.className = 'hidden';
                }

                if (firstNameElement.value !== '') {
                    firstNameLabelElement.className = 'hidden';
                }
                if (lastNameElement.value !== '') {
                    lastNameLabelElement.className = 'hidden';
                }
                if (phoneElement.value !== '') {
                    phoneLabelElement.className = 'hidden';
                }
                if (comoIdentificasElement.value !== '') {
                    comoIdentificasLabelElement.className = 'hidden';
                }
                if (proteinaPreferenciaElement.value !== '') {
                    proteinaPreferenciaLabelElement.className = 'hidden';
                }
                if (paraElement.value !== '') {
                    paraLabelElement.className = 'hidden';
                }

                // Tags
                tags = Array.isArray(customer.Tags) ? [...customer.Tags] : [];
                renderTags();

                // Metafields
                additionalMetafields = [];

                // Load required metafields from customer data
                CONFIG.REQUIRED_METAFIELDS.forEach(requiredField => {
                    let value = '';
                    let id = null;

                    // Try to find in customer's metafields
                    if (customer.Metafields) {
                        const found = customer.Metafields.find(mf => mf.node.key === requiredField.key);
                        if (found) {
                            value = found.node.value || '';
                            id = found.node.id || null;
                        }
                    }

                    // Map to form fields (special handling for some fields)
                    const formFieldMap = {
                        //'cumplea_os': 'cumplea_os',
                        //'genero': 'genero',
                        //'nmero_y_calle': 'nmero_y_calle',
                        //'cdigo_postal': 'cdigo_postal',
                        'cmo_te_identificas': 'cmo_te_identificas',
                        'protena_de_preferencia': 'proteina_preferencia',
                        'tus_compras_son_para': 'tus_compras_son_para',
                        //'mtodo_de_pago_de_preferencia': 'metodo_pago',
                        //'recurrencia_de_compra': 'recurrencia_compra',
                        //'ife': 'ife',
                        //'numero_sukarne': 'numero_sukarne'
                    };

                    const formFieldId = formFieldMap[requiredField.key];
                    if (formFieldId) {
                        const formField = document.getElementById(formFieldId);
                        if (formField) {
                            if (requiredField.type === 'list.single_line_text_field') {
                                try {
                                    const parsedValue = JSON.parse(value);
                                    formField.value = Array.isArray(parsedValue) && parsedValue.length > 0 ? parsedValue[0] : '';
                                } catch {
                                    formField.value = value;
                                }
                            } else {
                                formField.value = value;
                            }
                        }
                    }

                    // Add to additionalMetafields for API operations
                    additionalMetafields.push({
                        id: id,
                        namespace: requiredField.namespace,
                        key: requiredField.key,
                        value: value,
                        type: requiredField.type,
                        columnName: requiredField.columnName
                    });
                });

                // Add any additional metafields comment if not needed
                /*if (customer.Metafields) {
                    customer.Metafields.forEach(metafield => {
                        if (!CONFIG.REQUIRED_METAFIELDS.some(field => field.key === metafield.node.key)) {
                            additionalMetafields.push({
                                id: metafield.node.id,
                                namespace: metafield.node.namespace,
                                key: metafield.node.key,
                                value: metafield.node.value,
                                type: metafield.node.type || 'string',
                                columnName: metafield.node.key || ''
                            });
                        }
                    });
                }*/

                renderMetafields();
                modalTitle.textContent = '¡Completa tu registro!';
                submitButton.textContent = 'Actualizar Cliente';
            }

            function getFormData() {
                const basicData = {
                    email: document.getElementById('email').value,
                    first_name: document.getElementById('first_name').value,
                    last_name: document.getElementById('last_name').value,
                    phone: document.getElementById('phone').value,
                    tags: [...tags]
                };

                // Prepare metafields data
                const metafields = [...additionalMetafields];

                // Update required metafields from form fields
                CONFIG.REQUIRED_METAFIELDS.forEach(requiredField => {
                    const formFieldMap = {
                        //'cumplea_os': 'cumplea_os',
                        //'genero': 'genero',
                        //'nmero_y_calle': 'nmero_y_calle',
                        //'cdigo_postal': 'cdigo_postal',
                        'cmo_te_identificas': 'cmo_te_identificas',
                        'protena_de_preferencia': 'proteina_preferencia',
                        'tus_compras_son_para': 'tus_compras_son_para',
                        //'mtodo_de_pago_de_preferencia': 'metodo_pago',
                        //'recurrencia_de_compra': 'recurrencia_compra',
                        //'ife': 'ife',
                        //'numero_sukarne': 'numero_sukarne'
                    };

                    const formFieldId = formFieldMap[requiredField.key];
                    if (formFieldId) {
                        const formField = document.getElementById(formFieldId);
                        if (formField) {
                            let value = formField.value;
                            /*if (requiredField.type === 'list.single_line_text_field' && value) {
                                value = JSON.stringify([value]);
                            }*/

                            const existingIndex = metafields.findIndex(mf => mf.key === requiredField.key);
                            if (existingIndex !== -1) {
                                metafields[existingIndex].value = value || '';
                            }
                        }
                    }
                });

                return {
                    ...basicData,
                    metafields
                };
            }

            async function handleSubmit(event) {
                event.preventDefault();
                
                if (isLoading) return;
                clearError();
                if (!formCustomerRegistration.reportValidity()) return;

                try {
                    showLoading();
                    
                    const formData = getFormData();
                    
                    if (currentCustomer) {
                        // Update customer
                        const updatedCustomer = await api.updateCustomer(currentCustomer.CodigoCliente, {
                            email: formData.email,
                            first_name: formData.first_name,
                            last_name: formData.last_name,
                            phone: formData.phone,
                            tags: formData.tags
                        });

                        if (updatedCustomer && updatedCustomer.customer?.customerUpdate?.userErrors?.length) {
                            const mensajesCliente = mapShopifyUserErrorsToSpanish(
                                updatedCustomer.customer.customerUpdate.userErrors
                            );

                            const mensajeFinal = mensajesCliente.join('\n');
                            
                            showCustomAlert(mensajeFinal, "");
                            return;
                        }

                        // Update metafields
                        for (const metafield of formData.metafields) {
                            await api.setMetafield(currentCustomer.CodigoCliente, {
                                id: metafield.id,
                                namespace: metafield.namespace,
                                key: metafield.key,
                                value: metafield.value,
                                type: metafield.type
                            });
                        }

                        showCustomAlert(
                        "Datos actualizados exitosamente",
                        "https://sukarneexpress.com"
                        );
                    } else {
                        // Create new customer
                        let customerResponse = await api.createCustomer({
                                email: formData.email,
                                first_name: formData.first_name,
                                last_name: formData.last_name,
                                phone: formData.phone,
                                tags: formData.tags
                            });

                        if (customerResponse && customerResponse?.customer?.customerCreate?.userErrors?.length) {
                            const customerMessages = mapShopifyUserErrorsToSpanish(
                                customerResponse.customer.customerCreate.userErrors
                            );

                            const mensajeFinal = customerMessages.join('\n');
                            
                            showCustomAlert(mensajeFinal, "");
                            return;
                        }

                        // Create metafields
                        if(customerResponse?.status) {
                            for (const metafield of formData.metafields) {
                                await api.setMetafield(customerResponse.customer.id, {
                                    namespace: metafield.namespace,
                                    key: metafield.key,
                                    value: metafield.value || '',
                                    type: metafield.type
                                });
                            }
                        
                            showCustomAlert(
                            "Cliente creado exitosamente, por favor revisa el mensaje enviado a tu correo electronico para completar el registro.",
                            "https://sukarneexpress.com/account/login"
                            );
                        }
                    }
                } catch (error) {
                    showError(getFriendlyErrorMessage(error));
                } finally {
                    hideLoading();
                }
            }

            async function loadInitialData() {
                try {
                    showLoading();
                    
                    // console.log("CUSTOMER DATA:", customerSession);
                    const email = customerSession && customerSession.email;

                    let customerData = null;

                    if (email) {
                        // Search for customer by id
                        const response = await api.getCustomers({
                            query: `id:'${customerSession.id}'`,
                            limit: 1
                        });
                        // console.log("RESPUESTA GETCUSTOMERS:", response);
                        if (response.customers && response.customers.length > 0) {
                            customerData = response.customers[0];
                        }
                    }

                    if (customerData) {
                        loadCustomerData(customerData);
                    } else {
                        // New customer mode
                        customerSession.email && (modalTitle.textContent = '');
                        submitButton.textContent = 'Registrarse';
                        
                        // Initialize with empty required metafields
                        CONFIG.REQUIRED_METAFIELDS.forEach(requiredField => {
                            additionalMetafields.push({
                                id: null,
                                namespace: requiredField.namespace,
                                key: requiredField.key,
                                value: '',
                                type: requiredField.type,
                                columnName: requiredField.columnName
                            });
                        });
                        renderMetafields();
                    }

                    // If email was provided in query, pre-fill the email field
                    if (email && !customerData) {
                        document.getElementById('email').readOnly = true;
                    }
                } catch (error) {
                    showError('No pudimos cargar tus datos. Puedes intentarlo nuevamente recargando la página.');
                } finally {
                    hideLoading();
                }
            }

            // Event Listeners
            if (customerSession.email) {
                closeButton.addEventListener('click', () => {
                    modal.style.display = 'none';
                });
                cancelButton.addEventListener('click', () => {
                    modal.style.display = 'none';
                });
            }

            formCustomerRegistration.addEventListener('submit', handleSubmit);

            addTagButton.addEventListener('click', () => {
                addTag(newTagInput.value);
            });

            newTagInput.addEventListener('keypress', (event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    addTag(newTagInput.value);
                }
            });

            function showCustomAlert(message, redirectUrl) {
                const modal = document.getElementById("customModal");
                const msg = document.getElementById("modalMessage");
                const btn = document.getElementById("modalButton");

                msg.textContent = message;
                modal.style.display = "flex";

                btn.onclick = () => {
                modal.style.display = "none";
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                }
                };
            } 

            addMetafieldButton.addEventListener('click', addMetafield);

            // Initialize
            window.updateMetafield = updateMetafield;
            window.removeMetafield = removeMetafield;

            // Load data when page loads
            window.addEventListener('DOMContentLoaded', loadInitialData);
        }

        const SHOPIFY_ERROR_MAP = {
        // PHONE
        'phone:Phone has already been taken': 'El número de teléfono fue previmente registrado intenta con uno diferente.',
        'phone:Invalid phone number': 'El número de teléfono no es válido.',

        // EMAIL
        'email:Email has already been taken': 'El correo electrónico ya está registrado.',
        'email:Email is invalid': 'El correo electrónico no es válido.',

        // NAME
        'first_name:First name is invalid': 'El nombre no es válido.',
        'last_name:Last name is invalid': 'El apellido no es válido.',

        // GENERIC
        'generic': 'Ocurrió un error al actualizar tus datos. Intenta nuevamente.'
        };

        function mapShopifyUserErrorsToSpanish(userErrors) {
        if (!Array.isArray(userErrors) || userErrors.length === 0) return [];

        return userErrors.map(function (err) {
            const field =
            Array.isArray(err.field) && err.field.length
                ? err.field[0]
                : 'generic';

            const key = field + ':' + err.message;

            return SHOPIFY_ERROR_MAP[key] || SHOPIFY_ERROR_MAP.generic;
        });
        }
